import { FC, ReactNode } from 'react';

import { Container } from '../common/Container';
import { Flex } from '../common/Flex';
import { Text } from '../common/Text';

import styles from './IntegrationsHero.module.scss';
import {
  IntegrationsHeroBoltIcon,
  IntegrationsHeroGlobeIcon,
  IntegrationsHeroShieldIcon,
} from './IntegrationsHeroIcons';

type BadgeProps = {
  icon: ReactNode;
  label: string;
};

function Badge(props: BadgeProps) {
  const { icon, label } = props;

  return (
    <span className={styles.badge}>
      <span className={styles.badgeIcon} aria-hidden>
        {icon}
      </span>

      <Text type="regular14" whiteSpace="normal">
        {label}
      </Text>
    </span>
  );
}

export const IntegrationsHero: FC = () => {
  return (
    <Container className={styles.root}>
      <div className={styles.inner}>
        <Flex direction="column" alignItems="flexStart">
          <div className={styles.sectionLabel}>
            <span className={styles.sectionLabelLine} aria-hidden />

            <Text type="medium14" color="green" className={styles.sectionEyebrow}>
              Integrations
            </Text>
          </div>

          <Text type="regular48" color="white" className={styles.title}>
            Ready-to-Use Integration Solutions
          </Text>

          <Text type="regular16" color="white50" whiteSpace="normal" className={styles.description}>
            Find the perfect payment configuration for your region and business model. SmartGates supports over 100+
            integration scenarios for global pay-ins and mass pay-outs.
          </Text>

          <Flex className={styles.badges} gap={12} wrap="wrap" alignItems="center" childMinSize="unset">
            <Badge icon={<IntegrationsHeroGlobeIcon />} label="100+ Scenarios" />

            <Badge icon={<IntegrationsHeroShieldIcon />} label="PCI DSS Compliant" />

            <Badge icon={<IntegrationsHeroBoltIcon />} label="Instant Setup" />
          </Flex>
        </Flex>
      </div>
    </Container>
  );
};
